export default ($api) => ({
  mediaPage: (data) => {
    return $api.get(`media-page`, { params: data })
  },
})
